import React, { useState, useEffect } from "react"
import jwt from "jsonwebtoken"
import { useHistory } from "react-router-dom"
// Reactstrap
import { Button } from "reactstrap"
import { connect } from "react-redux"
import ProfileMenu from "./Dropdowns/ProfileMenu"
import Logo from "../Logo"
import { useWallet } from "../../libs/useMetaMaskWallet"
import WalletInfo from "./WalletInfo"
import { toggleSideMenu } from "../../store/common/commonActions"
import WalletOptions from "./WalletOptions"

const Header = (props) => {
    const { toggleSideMenu, sideMenuCollapsed } = props
    const [isSearch, setIsSearch] = useState(false)
    const toggleMenu = () => toggleSideMenu(!sideMenuCollapsed)
    const history = useHistory()

    const toggleFullscreen = () => {
        if (
            !document.fullscreenElement &&
            /* alternative standard method */ !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen()
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen()
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen()
            }
        }
    }
    useEffect(() => {
        if (localStorage.jwtToken) {
            try {
                var decoded = jwt.decode(localStorage.jwtToken)
                if (new Date().getTime() < decoded.exp * 1000) {
                    setTimeout(() => {
                        history.push("/logout")
                        history.push("/login")
                    }, decoded.exp * 1000 - new Date().getTime())
                }
            } catch (err) {
                console.log(err)
            }
        }
    }, [])

    return (
        <React.Fragment>
            <header id="page-topbar">
                <div className="navbar-header">
                    <div className="d-flex">
                        <Logo />

                        <button
                            type="button"
                            onClick={toggleMenu}
                            className="btn btn-sm px-3 font-size-16 header-item waves-effect"
                            id="vertical-menu-btn"
                        >
                            <i className="fa fa-fw fa-bars"></i>
                        </button>
                    </div>
                    <div className="d-flex">
                        <div className="dropdown d-inline-block d-lg-none ml-2">
                            {/* <button
                onClick={() => setIsSearch(!isSearch)}
                type="button"
                className="btn header-item noti-icon waves-effect"
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify"></i>
              </button>
              <div
                className={
                  isSearch
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div> */}
                        </div>

                        <div className="dropdown d-none d-lg-inline-block ml-1">
                            <button
                                type="button"
                                onClick={toggleFullscreen}
                                className="btn header-item noti-icon waves-effect"
                                data-toggle="fullscreen"
                            >
                                <i className="bx bx-fullscreen"></i>
                            </button>
                        </div>
                        <WalletOptions />
                        <ProfileMenu />
                    </div>
                </div>
            </header>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => ({
    sideMenuCollapsed: state.commonReducer.sideMenuCollapsed
})

const mapDispatchToProps = {
    toggleSideMenu
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
